module.exports = __webpack_public_path__ + "img/santos.6771f98b.svg";